'use strict';

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _styled = require('styled-components');

var React = require('react');

var index = require('./index-6b8189f0.js');

var useInside_esm = require('./use-inside.esm-3f28ebaf.js');

var DiscButton = require('./DiscButton.js');

var Popover = require('./Popover.js');

var Theme = require('./Theme.js');

var IconQuestion = require('./IconQuestion.js');

var constants = require('./constants.js');

var textStyles = require('./text-styles.js');

require('./extends-214be52a.js');

require('./_commonjsHelpers-b3309d7b.js');

require('./ButtonBase.js');

require('./FocusVisible.js');

require('./defineProperty-754b29ce.js');

require('./keycodes.js');

require('./css.js');

require('./environment.js');

require('./miscellaneous.js');

require('./proptypes-77f6d5c1.js');

require('./react-spring-web.esm-b5843e07.js');

require('react-dom');

require('./RootPortal.js');

require('./Root-e3b39caa.js');

require('./components.js');

require('./springs.js');

require('./theme-dark.js');

require('./theme-light.js');

require('./color.js');

require('./IconPropTypes-0ef380f7.js');

require('./font.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _styled__default = /*#__PURE__*/_interopDefaultLegacy(_styled);

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function Help(_ref) {
  var hint = _ref.hint,
      children = _ref.children;
  var theme = Theme.useTheme();
  var buttonElement = React.useRef();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];

  var open = React.useCallback(function () {
    return setVisible(true);
  }, []);
  var close = React.useCallback(function () {
    return setVisible(false);
  }, []);

  var _useInside_esm$useIns = useInside_esm.useInside('Box:heading'),
      _useInside_esm$useIns2 = _slicedToArray(_useInside_esm$useIns, 1),
      insideBoxHeading = _useInside_esm$useIns2[0];

  var _useInside_esm$useIns3 = useInside_esm.useInside('Field:label'),
      _useInside_esm$useIns4 = _slicedToArray(_useInside_esm$useIns3, 1),
      insideFieldLabel = _useInside_esm$useIns4[0];

  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(_StyledDiscButton, {
    ref: buttonElement,
    description: hint,
    onClick: open,
    size: 2 * constants.GU,
    $_css: insideFieldLabel ? -3 : 0,
    $_css2: insideBoxHeading || insideFieldLabel ? 1 * constants.GU : 0
  }, /*#__PURE__*/React__default["default"].createElement(IconQuestion["default"], {
    size: "tiny"
  })), /*#__PURE__*/React__default["default"].createElement(_StyledPopover, {
    opener: buttonElement.current,
    visible: visible,
    onClose: close,
    $_css3: textStyles.textStyle('body3')
  }, /*#__PURE__*/React__default["default"].createElement(_StyledDiv, {
    $_css4: 48 * constants.GU,
    $_css5: 20 * constants.GU,
    $_css6: 3 * constants.GU,
    $_css7: theme.helpSurface,
    $_css8: 0.5 * constants.GU,
    $_css9: theme.help
  }, children)));
}

Help.propTypes = {
  hint: index.PropTypes.string.isRequired,
  children: index.PropTypes.node.isRequired
};

var _StyledDiscButton = _styled__default["default"](DiscButton["default"]).withConfig({
  displayName: "Help___StyledDiscButton",
  componentId: "sc-1rc2q3j-0"
})(["margin-top:", "px;margin-left:", "px;"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
});

var _StyledPopover = _styled__default["default"](Popover["default"]).withConfig({
  displayName: "Help___StyledPopover",
  componentId: "sc-1rc2q3j-1"
})(["border:0;overflow:hidden;", ";"], function (p) {
  return p.$_css3;
});

var _StyledDiv = _styled__default["default"]("div").withConfig({
  displayName: "Help___StyledDiv",
  componentId: "sc-1rc2q3j-2"
})(["position:relative;max-width:", "px;min-width:", "px;padding:", "px;background:", ";&:before{content:'';position:absolute;top:0;left:0;bottom:0;width:", "px;background:", ";}"], function (p) {
  return p.$_css4;
}, function (p) {
  return p.$_css5;
}, function (p) {
  return p.$_css6;
}, function (p) {
  return p.$_css7;
}, function (p) {
  return p.$_css8;
}, function (p) {
  return p.$_css9;
});

exports["default"] = Help;